import {
    Badge,
    Box,
    Button,
    Group,
    JsonInput,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { useEffect, useRef } from 'react';

import { useForm } from '@mantine/form';

const JsonOptionsModal = ({ header, jsonObj, opened, close }) => {
    const form = useForm({
        initialValues: {
            json: JSON.stringify(jsonObj),
        },
        validate: {},
    });

    useEffect(() => {
        form.setFieldValue('json', JSON.stringify(jsonObj));
    }, [jsonObj]);

    const onSubmit = (values) => {};

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'md'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>{header}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <JsonInput
                            value={JSON.stringify(jsonObj)}
                            autoFocus
                            formatOnBlur
                            autosize
                            {...form.getInputProps('json')}
                        />
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default JsonOptionsModal;
